import axios from "axios";

const axiosInstance = axios.create({
   // baseURL: "http://localhost:8000/api"
   baseURL: "https://unrealrp.com.ua/api"
});

export default axiosInstance;